import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import main from '../../components/index/main'

Vue.use(Router)

const routes = [
  {
    path: '/main',
    component: main
  }
  // ,{
  //   path: '/admin',
  //   component: index,
  //   meta: { requiresAuth: true },
  //   children: [
  //     {
  //       path: 'food_org_home',
  //       name: 'food_org_home',
  //       component: food_org_home,
  //       children: [
  //             { path: 'food_org_food/:id', name: 'food_org_food', component: food_org_food },
  //             { path: 'food_org_add', name: 'food_org_add', component: food_org_add },
  //             { path: 'food_org_edit', name: 'food_org_edit', component: food_org_edit },
  //             { path: 'food_org_detail', name: 'food_org_detail', component: food_org_detail },
  //             { path: 'food_org_import', name: 'food_org_import', component: food_org_import }
  //       ]
  //     }
      // ,{
      //   path: 'inspectionbank',
      //   name: 'inspectionbank',
      //   component: inspectionbank,
      //   children: [
      //         { path: 'rulemain/:id/:name', name: 'rulemain', component: rulemain }
      //   ]
      // }
  //   ]
  // }

]

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
// const router = new VueRouter({
//   // mode: 'history',
//   routes // （缩写）相当于 routes: routes
// })

// 4. 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能
export default new Router({
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index/index.js